import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { ConfigProvider } from '../../providers/config/config';
import { AppState } from '../../config/state';
import { DatabaseProvider } from '../database/database';

@Injectable()
export class ClientDetailsProvider {

  constructor(private api: ApiProvider, private config: ConfigProvider, private state: AppState, private db: DatabaseProvider) {
  }

  async load(): Promise<ClientData> {
    const cfg = await this.config.load(this.state.appId);
    const query = `{
      client(id: ${cfg.clientId}){
        id, name, longName, keyword, socialIcons,
        timezone{
          offset, string
        },
        ilsType, catalogType, authenticationType, settings
      }
    }`;
    return this.api.getData(query, 'id', cfg.clientId);
  }

  async userClasses(): Promise<UserClass[]> {
    const cfg = await this.config.load(this.state.appId);
    const query = `{
      userClasses(id: ${cfg.clientId}) {
        id
        name,
        type
      }
    }`;
    return this.api.getDataArray(query, 'id');
  }

}

export interface UserClass {
  id: number,
  name: string,
  type: number
}

export interface ClientData {
  name: string
  longName?: string
  keyword: string
  socialIcons?: boolean
  timezone?: { offset: any, string: string }
  ilsType?: string
  catalogType?: string
  authenticationType?: string
  evanced?: any
  settings?: any
}



// WEBPACK FOOTER //
// ./src/providers/client-details/client-details.ts